import React, { useState } from 'react';
import {
	PrimaryButton,
	DefaultButton,
	Stack,
	Text,
} from 'office-ui-fabric-react';
import { Header } from 'components';
// import FooterTexts from '../../../components/common/Footer/FooterTexts';
// import { dataPopulationInput } from 'containers/phoenix/utils/excelUtil';

const Wizard = ({ steps, currentStep, setCurrentStep, isError, getData }) => {
	// const [currentStep, setCurrentStep] = useState(0);
	const stackTokens = { childrenGap: 0 };

	// const { backWarningMessage, backText, nextText } = FooterTexts;

	return (
		<div className="ms-Grid" dir="ltr">
			<Header />
			<div>{steps[currentStep].content}</div>
			<div className="footer-container">
				<div
					className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 footer-fixed rectangle"
					style={{ display: 'flex' }}
				>
					<div className="ms-Grid-col ms-sm5 ms-md5 ms-lg5">
						<Text variant="smallPlus" className="service-name">
							{steps[currentStep].title}
						</Text>
						<div>
							<Text variant="medium" className="step-page">
								Step {currentStep + 1} of {steps.length}
							</Text>
						</div>
					</div>
					<div className="ms-Grid-col ms-sm7 ms-md7 ms-lg7">
						<Stack
							horizontal
							tokens={stackTokens}
							horizontalAlign="end"
						>
							<DefaultButton
								id="backButton"
								text="Back"
								onClick={() => {
									setCurrentStep(currentStep - 1);
								}}
								// disabled={isButtonDisable}
							/>
							{currentStep < steps.length - 1 ? (
								<PrimaryButton
									id="next"
									type="showNextButton"
									text="Next"
									onClick={() => {
										// dataPopulationInput(data);
										setCurrentStep(currentStep + 1);
									}}
								/>
							) : (
								<PrimaryButton
									id="getData"
									type="showNextButton"
									text="Get Data"
									onClick={isError ? null : getData}
									style={{ textWrapMode: 'nowrap' }}
									disabled={isError}
								/>
							)}
						</Stack>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Wizard;
